import { Icon } from '@iconify/react';
import { Dialog, DialogContent, DialogTitle } from '@/components/shadcn/dialog';

interface HostInfoDialogProps {
  open: boolean;
  title: string;
  message: string;
  icon: string;
  onClose: () => void;
}

export function HostInfoDialog({ open, title, message, icon, onClose }: HostInfoDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onClose(); }}>
      <DialogContent
        showCloseButton={false}
        className="max-w-sm rounded-3xl p-6 bg-white text-center gap-0"
      >
        <div className="w-14 h-14 rounded-full bg-orange-50 text-[#FC480D] flex items-center justify-center mx-auto mb-4">
          <Icon icon={icon} className="w-7 h-7" />
        </div>
        <DialogTitle className="text-base font-extrabold text-[#0E1726] mb-2">{title}</DialogTitle>
        <p className="text-sm text-gray-400 font-medium leading-relaxed whitespace-pre-line">
          {message}
        </p>
        <button
          type="button"
          onClick={onClose}
          className="mt-5 w-full h-11 rounded-full bg-[#FC480D] hover:bg-[#e03e09] text-white text-sm font-extrabold cursor-pointer"
        >
          Mengerti
        </button>
      </DialogContent>
    </Dialog>
  );
}

interface HostConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  loading?: boolean;
  danger?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function HostConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  loading = false,
  danger = false,
  onCancel,
  onConfirm,
}: HostConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next && !loading) onCancel(); }}>
      <DialogContent
        showCloseButton={false}
        className="max-w-sm rounded-3xl p-6 bg-white text-center gap-0"
      >
        <DialogTitle className="text-base font-extrabold text-[#0E1726] mb-2">{title}</DialogTitle>
        <p className="text-sm text-gray-400 font-medium leading-relaxed">{message}</p>
        <div className="mt-5 flex flex-col gap-2.5">
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={`w-full h-11 rounded-full text-white text-sm font-extrabold cursor-pointer disabled:opacity-60 ${
              danger ? 'bg-red-500 hover:bg-red-600' : 'bg-[#FC480D] hover:bg-[#e03e09]'
            }`}
          >
            {loading ? 'Memproses...' : confirmLabel}
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="w-full h-11 rounded-full bg-gray-100 text-gray-700 text-sm font-bold cursor-pointer disabled:opacity-60"
          >
            Batal
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
